import * as CouponRateActions from 'actions/CouponRate';
import * as MakeBetActions from 'actions/MakeBet';

export default function amountReducer(amount, action) {
    switch (action.type) {
        case CouponRateActions.SET_COUPON_AMOUNT:
            return action.data;
        case MakeBetActions.SUCCESS_MAKE_BET:
            const createdBets = action.data;

            for (let offset = 0; offset < createdBets.length; offset++) {
                const createdBet = createdBets[offset];

                if (createdBet.error !== undefined && createdBet.error) {
                    if(createdBet.error === -18){
                        return 0
                    }
                }
            }
    }

    return amount;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/amountReducer.js